function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.2,21.8l7.8,7.8c1.6,1.6,3.2,3.2,4.8,4.8c0.9,0.6,1,1.8,0.4,2.6c-0.1,0.1-0.2,0.2-0.3,0.3c-1.2,1.2-2.4,2.4-3.6,3.6 c-0.6,0.8-1.7,0.9-2.5,0.3c-0.1-0.1-0.1-0.2-0.2-0.3L7.8,23.1c-0.8-0.5-1-1.6-0.5-2.3c0.1-0.2,0.3-0.3,0.5-0.5 c5.9-5.9,11.8-11.8,17.8-17.7c0.6-0.8,1.7-0.9,2.4-0.3c0.1,0.1,0.2,0.2,0.3,0.3c1.2,1.2,2.3,2.3,3.5,3.5s1,2,0,3 c-3.9,4-7.9,7.9-11.9,11.9C19.7,21.3,19.5,21.5,19.2,21.8z"
});

var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 42.5",
    style: {
      enableBackground: "new 0 0 39.7 42.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-left.0bd40d8f.svg";
export { ForwardRef as ReactComponent };